export interface Notification {
  addedAt: string;
  uuid: string;
}

export interface EmailNotification extends Notification {
  email: {
    body: string;
    from: {
      value: string;
    };
    htmlBody: string;
    recipients: {
      to: [
        {
          value: string;
        },
      ];
    };
    subject: string;
  };
}
interface Phonenumber {
  countryCode: string;
  nationalNumber: string;
}
export interface PhoneNotification extends Notification {
  label: {
    value: string;
  };
  sms: {
    body: string;
    fromNumber: Phonenumber;
    toNumber: Phonenumber;
  };
}

export interface AllowanceResponse {
  data?: {
    allowance?: {
      emailAddress?: {
        value: boolean;
      };
      phoneNumber?: {
        value: boolean;
      };
      value: string;
    };
  };
  error?: string;
  success: boolean;
}
export interface WhiteListPhoneFormDTO {
  phone_number: {
    country_code: number;
    national_number: number;
  };
  validUntil?: string;
  value: string;
}

export interface WhiteListEmailFormDTO {
  email_address: {
    value: string;
  };
  validUntil?: string;
  value: string;
}
export interface NotificationAllowanceUpdatePostBody {
  allowances: (WhiteListEmailFormDTO | WhiteListPhoneFormDTO)[];
}

export interface NotificationResponse {
  data?: {
    notifications?: (EmailNotification | PhoneNotification)[];
  };
  error?: string;
  success: boolean;
}

export interface NotifiationAllowanceParams {
  email?: string;
  phoneNumber?: string;
}
export interface GetNotificationsParams {
  before?: string;
  email?: string;
  limit?: number;
  phoneNumber?: string;
}

export interface NotificationStatusObject {
  current: NotificationStatus;
  history: NotificationStatus[];
}

export interface NotificationTableEntry {
  addedAt: string;
  body: string;
  errorContext?: {
    errorMessage: string;
    grpcStatusCode: string;
  };
  from?: string; // Only for email type
  fromNumber?: string; // Only for sms type
  htmlBody?: string; // Only for email type
  status: NotificationStatusObject | null;
  subject?: string; // Only for email type
  to?: string; // Only for email type
  toNumber?: string; // Only for sms type
  type: 'email' | 'sms';
  uuid: string;
}

export interface NotificationStatusResponse {
  data?: {
    statuses?: {
      [key: string]: NotificationStatusObject;
    };
  };
  error?: string;
  success: boolean;
}

export interface NotificationStatus {
  direction: string;
  errorContext?: {
    errorMessage: string;
    grpcStatusCode: string;
  };
  notificationUuid: string;
  provider: string;
  status: NotificationStatusEnum;
  statusAt: string;
  type: string;
  uuid: string;
}

export enum NotificationStatusEnum {
  SUCCEEDED = 'SUCCEEDED',
  ABORTED = 'ABORTED',
  FAILED = 'FAILED',
  SENT = 'SENT',
  QUEUED = 'QUEUED',
  THROTTLED = 'THROTTLED',
}
